import CarriersListContainer from "../../../components/asset-management/CarriersList";

export default function Carriers() {
  return <CarriersListContainer />;
}
